module.exports = __webpack_public_path__ + "b6288314a37291c24abec120d9e46fca.png";